import { Box } from '@mui/system';

import { YellowBackgroundSVG } from 'src/assets/images';

export const YellowLayout: React.FC = ({ children }) => {
    return (
        <Box height="100vh" width="100vw" position="relative" overflow="hidden">
            <Box position="absolute" width="100vw" zIndex={0}>
                <YellowBackgroundSVG height="100%" width="100vw" />
            </Box>
            <Box position="absolute" height="100vh" width="100vw">
                {children}
            </Box>
        </Box>
    );
};
